
function updateTimer() {
  // Current time in Spain
  const now = new Date().toLocaleString("en-US", { timeZone: "Europe/Madrid" });
  const spainNow = new Date(now);

  // Next midnight in Spain
  const midnight = new Date(spainNow);
  midnight.setHours(24, 0, 0, 0);

  // Difference in milliseconds
  const diff = midnight - spainNow;

  const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, '0');
  const minutes = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, '0');
  const seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, '0');

  document.getElementById("announcetimer").textContent = `${hours}:${minutes}:${seconds}`;
}

updateTimer();
setInterval(updateTimer, 1000);
